import React, { useEffect } from 'react'
import HowWeCanHelp from '../common/HowWeCanHelp'
import Image from "../../assets/image/png/blog-image.png"
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getSingleBlog } from '../../redux/slice/blogSlice'
import HTMLReactParser from 'html-react-parser'
export const BlogDetails = () => {
    const { blogDetails } = useSelector(state => state.blog)
    const { id } = useParams();
    const dispatch = useDispatch()
    useEffect(() => {
        if (id) {
         dispatch(getSingleBlog(id))
        }
    }, [id])
    return (

        <div className='background_light'>
            <div className='container'>
                <div className="row py-5 justify-content-between" >
                    <div className="col-md-7">
                        <h1 className='fw-bold ff_inter fs_37 color_darkgray'>{blogDetails.title}</h1>
                        <img className='mt-4 w-100 rounded-4' src={blogDetails.image} alt="Image" />
                        <div className='blogDetailsWrapper mt-5'>
                            {HTMLReactParser(blogDetails?.description||"")}
                        </div>
                    </div>
                    <HowWeCanHelp />
                </div>
            </div>
        </div>
    )
}
